import { PdfProps } from '@/components/Pdf/Pdf.types';
import { OpenFile, SpecialZoomLevel, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin, ToolbarProps, ToolbarSlot } from '@react-pdf-viewer/default-layout';
import { getFilePlugin } from '@react-pdf-viewer/get-file';
import { useTranslation } from 'react-i18next';

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import fr_FR from '@react-pdf-viewer/locales/lib/fr_FR.json';
import en_US from '@react-pdf-viewer/locales/lib/en_US.json';
import { ReactElement } from 'react';

const Pdf = (props: PdfProps) => {
  const { url, width, height, downloadButton, fileName } = props;
  const { i18n } = useTranslation();

  const getFilePluginInstance = getFilePlugin({
    fileNameGenerator: fileName
      ? (file: OpenFile) => {
          return fileName;
        }
      : undefined,
  });
  const { Download } = getFilePluginInstance;

  const renderToolbar = (Toolbar: (props: ToolbarProps) => ReactElement) => (
    <Toolbar>
      {(slots: ToolbarSlot) => {
        const { EnterFullScreen, Print, Zoom, ZoomIn, ZoomOut } = slots;
        return (
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
              width: '100%',
            }}
          >
            <div style={{ padding: '0px 2px' }}>
              <ZoomOut />
            </div>
            <div style={{ padding: '0px 2px' }}>
              <Zoom />
            </div>
            <div style={{ padding: '0px 2px' }}>
              <ZoomIn />
            </div>

            <div style={{ padding: '0px 2px', marginLeft: 'auto' }}>
              <EnterFullScreen />
            </div>
            <div style={{ padding: '0px 2px' }}>
              <Download />
            </div>
            <div style={{ padding: '0px 2px' }}>
              <Print />
            </div>
          </div>
        );
      }}
    </Toolbar>
  );
  // Create new plugin instance
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: () => [],
    renderToolbar,
  });

  return (
    <Viewer
      fileUrl={url}
      localization={i18n.language === 'fr' ? fr_FR : en_US}
      plugins={[defaultLayoutPluginInstance, getFilePluginInstance]}
      defaultScale={SpecialZoomLevel.PageFit}
    />
  );
};

export default Pdf;
